export async function getTokenWithTimeout(
  getTokenFn,
  options = {},
  timeoutMs = 8000
) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error('AUTH_TIMEOUT')),
      timeoutMs
    );
    getTokenFn(options)
      .then((token) => {
        clearTimeout(timer);
        resolve(token);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
}
